import React from 'react'

import {
  numberAddCommas,
  allowNumericOnly,
  numberWithCommas,
  presenceErrorClass
} from 'servos/formValidations'

class InputBox extends React.Component {
  disabledClass() {
    return (this.props.disabled ? 'disabled': '')
  }

  render() {
    const {
      id,
      onChange,
      value,
      noChildren,
      displayMonthly,
      errorMessage,
      disabled,
      type,
      inputMode,
    } = this.props

    return (
      <div className="input-box form-row">
        <div className="input-box__input-col col-6 col-sm-4">
          <div className={`input-group ${this.disabledClass()}`}>
            <div className="input-group-prepend">
              <div className={`input-group-text ${presenceErrorClass(errorMessage)}`}>
                $
              </div>
            </div>
            <input
              type={ type ? type : 'text' }
              inputMode={ inputMode ? inputMode : 'text' }
              id={id}
              readOnly={ disabled }
              onKeyPress={allowNumericOnly}
              onKeyUp={numberWithCommas}
              className={`form-control ${presenceErrorClass(errorMessage)}`}
              value={numberAddCommas(value)}
              onChange={onChange} />
          </div>
        </div>
        <div className="invalid-feedback">
          { errorMessage }
        </div>

        { displayMonthly &&
          <div className="col-auto align-self-center">
            <div className="text-muted monthly">
              monthly
            </div>
          </div>
        }
        { !noChildren && <div className="col-6 col-sm-4">
            {this.props.children}
          </div>
        }
      </div>
    )
  }
}

export default InputBox;
